import { createAction, props } from '@ngrx/store';
import {
  PendingLink,
  PendingLinkDecisionAction,
  PendingLinkDecisionPayload,
  PendingLinksBulkDecidePayload,
  PendingLinksExportPayload,
  PendingLinksListMeta,
} from '../models/pending-link.model';

export const loadPendingLinks = createAction(
  '[Pending Links] Load Pending Links',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    status?: string;
    sourceSurface?: string;
    sort?: string;
    sortDirection?: string;
  }>()
);

export const loadPendingLinksSuccess = createAction(
  '[Pending Links] Load Pending Links Success',
  props<{ pendingLinks: PendingLink[]; meta: PendingLinksListMeta }>()
);

export const loadPendingLinksFailure = createAction(
  '[Pending Links] Load Pending Links Failure',
  props<{ error: string }>()
);

export const decidePendingLink = createAction(
  '[Pending Links] Decide Pending Link',
  props<{ action: PendingLinkDecisionAction; payload: PendingLinkDecisionPayload }>()
);

export const decidePendingLinkSuccess = createAction(
  '[Pending Links] Decide Pending Link Success',
  props<{ action: PendingLinkDecisionAction }>()
);

export const decidePendingLinkFailure = createAction(
  '[Pending Links] Decide Pending Link Failure',
  props<{ error: string }>()
);

export const bulkDecidePendingLinks = createAction(
  '[Pending Links] Bulk Decide Pending Links',
  props<{ payload: PendingLinksBulkDecidePayload }>()
);

export const bulkDecidePendingLinksSuccess = createAction(
  '[Pending Links] Bulk Decide Pending Links Success'
);

export const bulkDecidePendingLinksFailure = createAction(
  '[Pending Links] Bulk Decide Pending Links Failure',
  props<{ error: string }>()
);

export const exportPendingLinks = createAction(
  '[Pending Links] Export Pending Links',
  props<{ payload: PendingLinksExportPayload }>()
);

export const exportPendingLinksSuccess = createAction(
  '[Pending Links] Export Pending Links Success',
  props<{ message?: string }>()
);

export const exportPendingLinksFailure = createAction(
  '[Pending Links] Export Pending Links Failure',
  props<{ error: string }>()
);

export const resetPendingLinksState = createAction('[Pending Links] Reset State');
